<section class="pc-notifications-page">
  <header class="pc-notifications-header">
    <div class="pc-notifications-header__copy">
      <div class="pc-title-row">
        <h2>Notifications</h2>
        @if (company.notifications?.length) {
          <span class="pc-count-badge">{{ company.notifications.length }}</span>
        }
      </div>
      <p>Schedule task summaries and choose which roles receive them.</p>
    </div>

    <div class="pc-notifications-header__actions">
      <button mat-stroked-button [disabled]="!dataUpdated() || saving" (click)="get()">
        <mat-icon>undo</mat-icon>
        Discard
      </button>
      <button mat-raised-button color="primary" [disabled]="!dataUpdated() || saving" (click)="save()">
        @if (saving) {
          <mat-spinner diameter="18" strokeWidth="3"></mat-spinner>
        } @else {
          <mat-icon>save</mat-icon>
        }
        {{ saving ? 'Saving…' : 'Save changes' }}
      </button>
    </div>
  </header>

  <div class="pc-notification-section-heading">
    <div>
      <h3>Scheduled summaries</h3>
      <p>Each schedule can target different roles and task filters.</p>
    </div>
    <button mat-stroked-button color="primary" (click)="addNoti()">
      <mat-icon>add</mat-icon>
      Add notification
    </button>
  </div>

  @if (!company.notifications?.length) {
    <div class="pc-empty-state">
      <span class="pc-empty-state__icon"><mat-icon>notifications_none</mat-icon></span>
      <h3>No notifications configured</h3>
      <p>Create a schedule to send task summaries to members of your team.</p>
      <button mat-raised-button color="primary" (click)="addNoti()">
        <mat-icon>add</mat-icon>
        Add your first notification
      </button>
    </div>
  } @else {
    <mat-accordion class="pc-notification-list" multi>
      @for (n of company.notifications; track n) {
        <app-notification-panel
          [notification]="n"
          [roles]="roles"
          (deleteNotification)="deleteNotification($event)">
        </app-notification-panel>
      }
    </mat-accordion>
  }

  @if (canSeeBlastNotifications) {
    <div class="pc-blast-card">
      <div class="pc-blast-card__heading">
        <span class="pc-blast-card__icon"><mat-icon>campaign</mat-icon></span>
        <div>
          <h3>Send an announcement</h3>
          <p>Immediately send a one-time push notification to your team.</p>
        </div>
      </div>

      <div class="pc-blast-form">
        <mat-form-field appearance="outline">
          <mat-label>Subject</mat-label>
          <input type="text" matInput [(ngModel)]="customSubject">
        </mat-form-field>
        <mat-form-field appearance="outline" class="pc-message-field">
          <mat-label>Message</mat-label>
          <textarea matInput rows="2" [(ngModel)]="customMessage"></textarea>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="blastNotification()">
          <mat-icon>send</mat-icon>
          Send now
        </button>
      </div>
    </div>
  }
</section>
